export enum ImportType {
  CommonCode = 1,
  StockMaster = 2,
  DefaultLedger = 3,
  User = 4,
  CompanyMaster = 5,
  ManageTenants = 6,
}
